import React, { useRef, useState } from 'react'
import SecBTN from '../../UI/SecBTN'
import classes from './UserInfo.module.css'
import InputWithEdit from '../../UI/InputWithEdit/InputWithEdit'
import Modals from '../../UI/Modals/Modals'
import SuccessModal from '../../UI/SuccessModal/SuccessModal'
import ConfirmationModal from '../../UI/ConfirmationModal/ConfirmationModal'

const UserInfo = (props) => {
  //From related states and functioning
  const x = JSON.parse(localStorage.getItem("user"));
    const [value, setValue] = useState({
      username:x?.data?.user?.user_name,
      mobile_number:x?.data?.user?.mobile,
      email_id:x?.data?.user?.email,
      // old_Password_retrieved:'12345',
      // old_Password_input:'',
      // password1:'',
      // password2:''
    });
    const [changePassword, setChangePassword] = useState(false);
    const pswdRef = useRef(null)
    const valueChangeHandler = (e) => {
      const { name, value } = e.target;
      setValue((prev) => {
        return ({
          ...prev,
          [name]: value,
        })
      });
      console.log([value])
    }
    //submit related
    const [showPopUp, setShowPopUp] = useState(false);
    const [showPopUp1,setShowPopUp1] = useState(false)
    const [showPopUp2,setShowPopUp2] = useState(false)
    const userInfoHandler = () =>{
      setShowPopUp(true)
    }
    const dataSubmitHandler = () => {
      setShowPopUp1(true)
      setShowPopUp(false)
    }
    const yesHandler = () => {
      setShowPopUp2(true)
      setShowPopUp1(false)
    }
    const onHideHandler = () => {
      setShowPopUp(false)
      setShowPopUp2(false)
      setShowPopUp1(false)
    }
   

  return (
    <>
      <i className="bx bx-user-circle" onClick={userInfoHandler}></i>
      <ConfirmationModal
        title="Do you want to Save Changes?"
        show={showPopUp1}
        onHide={onHideHandler}
        yesHandler={yesHandler}
        confirmTxt="Yes"
      />
      <SuccessModal
        show={showPopUp2}
        onHide={onHideHandler}
        title="Profile Changes Saved Successfully!"
        btnTxt="Ok"
      />
      <Modals
        className={classes.navModal}
        show={showPopUp}
        onHide={onHideHandler}
      >
        <h6 className="mb-3">User Profile</h6>
        <label className={classes.label} htmlFor="name">
          User Name
        </label>
        <InputWithEdit
          id="name"
          name="username"
          type="text"
          value={value.username}
          value1={value.username}
          onChange={valueChangeHandler}
        />
        <label className={classes.label} htmlFor="mobile_number">
          Mobile No.
        </label>
        <InputWithEdit
          id="mobile_number"
          name="mobile_number"
          type="number"
          value={value.mobile_number}
          value1={value.mobile_number}
          onChange={valueChangeHandler}
        />
        <label className={classes.label} htmlFor="email">
          Email Id
        </label>
        <InputWithEdit
          id="email"
          name="email_id"
          type="email"
          value={value.email_id}
          value1={value.email_id}
          onChange={valueChangeHandler}
        />
        {/* {!changePassword ? (
          <>
            <label className={classes.label} htmlFor="pswd">
              Password
            </label>
            <input
              className={`${classes.input} ${classes.disable} ${classes.onlyPswd}`}
              id="pswd"
              name="old_Password"
              type="password"
              value="············"
              disabled
            />
            <p
              className={classes["change-pswd"]}
              onClick={() => {
                setChangePassword(true);
                setTimeout(() => {
                  pswdRef.current.focus();
                }, 50);
              }}
            >
              Change Password
            </p>
          </>
        ) : (
          <>
            <label className={classes.label} htmlFor="old_Password_input">
              Old Password
            </label>
            <input
              className={classes.input}
              ref={pswdRef}
              id="old_Password_input"
              name="old_Password_input"
              type="password"
              value={value.old_Password_input}
              onChange={valueChangeHandler}
            />
            <label className={classes.label} htmlFor="new_password">
              New Password
            </label>
            <input
              className={classes.input}
              id="new_password"
              name="password1"
              type="password"
              value={value.password1}
              onChange={valueChangeHandler}
            />
            <label className={classes.label} htmlFor="cnfrm_password">
              Confirm Password
            </label>
            <input
              className={classes.input}
              id="cnfrm_password"
              name="password2"
              type="password"
              value={value.password2}
              onChange={valueChangeHandler}
            />
          </>
        )} */}

        <div className="text-center">
          <SecBTN onClick={dataSubmitHandler} className={classes.saveBtn}>
            Save Changes
          </SecBTN>
        </div>
      </Modals>
    </>
  );
}

export default UserInfo